import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import { DocumentationFormType } from '../../../../shared/base-new-request/base-new-request.model';
import {
  SFBCCNewRequestControlName,
  SFBCCNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class SFBCCNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<SFBCCNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup(
        {
          [SFBCCNewRequestControlName.ContactData]: true,
        },
        {
          documentationFormType: DocumentationFormType.NonElectronicForm,
        },
      ).controls,
      [SFBCCNewRequestControlName.ConstructionIntentionType]: [
        [],
        [Validators.required],
      ],
      [SFBCCNewRequestControlName.PlannedStartDate]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
    });
  }
}
